<template>
  <div class="loading">
    <b-loading :is-full-page="true" :active="true"></b-loading>
  </div>
</template>

<script>
import * as Auth0Lib from '@/libs/AuthService';

export default {
  name: 'callback',
  props: ['auth'],
  created() {
    Auth0Lib.handleAuthentication();
  },
};
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
